import { styled, css } from 'styled-components';

export const Container = styled.div`
  @media print {
    display: none !important;
  }
`;

export const Display = styled.div`
  ${({ theme: { borderRadius, colors, fontSizes, fontWeights, motionSpeeds, motions } }) => css`
    align-items: center;
    border: 1px solid ${colors.brandDarkTint80};
    border-radius: ${borderRadius.sm};
    box-sizing: border-box;
    color: ${colors.brandDark};
    cursor: pointer;
    display: flex;
    gap: 0.5rem;
    outline: 2px solid transparent;
    padding: 0.25rem 1rem 0.25rem 0.75rem;
    transition: all ${motionSpeeds.fast} ${motions.default};

    .icon {
      flex-shrink: 0;
      height: 1rem;
      width: 1rem;
    }

    span {
      display: block;
      font-size: ${fontSizes.s14};
      font-weight: ${fontWeights.medium};
    }

    &:focus-within,
    &:focus {
      background: ${colors.brandDarkAlpha5};
      outline-color: ${colors.brandPrimaryAlpha50};
      outline-offset: 2px;
    }

    * {
      user-select: none;
    }
  `}
`;

export const List = styled.div`
  ${({ theme: { borderRadius, colors } }) => css`
    background: ${colors.brandLight};
    border-radius: ${borderRadius.sm};
    box-shadow:
      0 0 0 1px ${colors.brandDarkTint80},
      0 0.75rem 0.5rem -0.25rem rgba(32, 30, 36, 0.15),
      0 0.25rem 0.25rem -0.125rem rgba(32, 30, 36, 0.2);
    display: flex;
    flex-direction: column;
    min-width: calc(50% + 0.35rem);
    padding: 0.25rem;
  `}
`;

export const ListItem = styled.button`
  ${({ theme: { borderRadius, colors, fontSizes, fontWeights, motionSpeeds, motions } }) => css`
    all: unset;
    align-items: center;
    border-radius: ${borderRadius.sm};
    cursor: pointer;
    display: flex;
    gap: 0.75rem;
    justify-content: space-between;
    outline: 2px solid transparent;
    padding: 0.75rem 1rem;
    transition: all ${motionSpeeds.fast} ${motions.default};

    p {
      color: ${colors.brandDark};
      flex: 1;
      font-size: ${fontSizes.s14};
      font-weight: ${fontWeights.medium};
      margin: 0;
      margin-right: 1rem;
    }

    span {
      color: ${colors.brandDarkTint30};
      font-size: ${fontSizes.s12};
    }

    .icon {
      height: 1rem;
      width: 1rem;
    }

    &:hover {
      background: ${colors.brandPrimaryAlpha5};

      p {
        color: ${colors.brandPrimary};
      }

      .icon {
        path {
          stroke: ${colors.brandPrimary};
        }
      }
    }

    &:focus-within,
    &:focus {
      outline-color: ${colors.brandPrimaryAlpha50};
      outline-offset: 2px;
    }
  `}
`;
